<template>
  <div>
    <div class="input-group">
      <textarea :placeholder="$t('placeholder')" class="description-new-task-card" disabled v-model="initialDescription">
        
      </textarea>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    initialDescription: {
      type: String, 
      default: ""
    }
  },
  i18n: {
    messages: {
      "pt-BR": {
        placeholder: 'Descreva sua atividade'
      },
      en: {
        placeholder: 'Describe your activity'
      }
    }
  }
}
</script>
